import { Link } from "react-router-dom";
import Auth from "../../shared/Auth";
import { qreq } from "../../shared/qrequest";
import BaseCom from "../BaseCom";
import Icon from "../Icon";
import { withParamsAndNavigate } from "../WithParamsAndNavigate";
import Card from "../Card";
import FormLabel from "../FormLabel";
import PurchaseOrders from "../PurchaseOrders";
import FormInput from "../FormInput";
import Alert from "../Alert";
import Address from "../Address";

class AccountView extends BaseCom {

    async componentDidMount() {
        await this.getSettings();
        await this.load();
        await this.loadRel();
        await this.loadAccounts();
    }

    async componentDidUpdate(prevProps) {
        if (this.props.params.id !== prevProps.params.id) {
            await this.load();
            await this.loadRel();
            await this.loadAccounts();
        }
    }

    load = async () => {
        try {
            let j = await qreq.getAsync(`/api/account/get/${this.props.params.id}`);
            if (j.item)
                this.setState({ item: j.item });
            else
                this.setState({ error: j.errorMessage });
        }
        catch (e) {
            this.unkownErrorCallback(e);
        }
    }

    loadRel = async () => {
        try {
            let j = await qreq.getAsync(`/api/account/rel/${this.props.params.id}`);
            if (j.list)
                this.setState({ rel: j.list });
            else {
                this.setState({ rel: [] });
            }
        }
        catch (e) {
            this.unkownErrorCallback(e);
        }
    }

    loadAccounts = async () => {
        try {
            await this.fillListAsync('/api/account/list', 'accounts');
        }
        catch { }
    }

    highlightSelf = (txt, id) => {
        if (!txt)
            return <i>None</i>;
        if (txt === this.state.item?.name)
            return <strong className="bg-warning p-1 rounded">{txt}</strong>;
        return <Link title="View Account" to={`/account/${id}`}>{txt}</Link>;
    }

    showAddRel = () => {
        this.setState({ rel: {}, showAddRel: true });
    }

    changeRel = () => {
        this.setState({ rel: { ...this.state.rel } });
    }

    submitRel = async (e) => {
        e?.preventDefault();
        try {
            let info = { ...this.state.rel };
            let j = await qreq.postAsync('/api/account/rel/save', info);
            if (j.errorCode === 0) {
                this.loadRel();
                this.setState({ showAddRel: false });
            }
            else
                this.alert(j.errorMessage);
        }
        catch (e) {
            this.unkownErrorCallback(e);
        }
    }

    render() {
        return (
            <div className="container-fluid">
                <h1>{this.state.error ? 'Account' : this.state.item?.name} {(Auth.hasRole('account-manager') || Auth.hasRole('distributor'))
                    && !this.state.error
                    && <Link to="edit" title="Edit Account" role="button">
                        <Icon icon="faPencil" />
                    </Link>}</h1>

                {!this.state.error && <>
                    
                    <div className="row">
                        <div className="col-md-6">
                            <Card title="Account Details">
                                <FormLabel label="Name" model={this.state.item?.name} />
                                <FormLabel label="Type" model={this.state.item?.accountTypeName} />
                            </Card>
                        </div>
                        {this.state.item?.address && this.state.item?.address.line1 && <div className="col-md-6">
                            <Card title="Contact Address">
                                <Address readOnly condensed item={this.state.item?.address} />
                            </Card>
                        </div>}
                        {this.state.item?.billingAddress && this.state.item?.billingAddress.line1 && <div className="col-md-6">
                            <Card title="Billing Address">
                                <Address readOnly condensed item={this.state.item?.billingAddress} />
                            </Card>
                        </div>}
                        {this.state.item?.shippingAddress && this.state.item?.shippingAddress.line1 && <div className="col-md-6">
                            <Card title="Shipping Address">
                                <Address readOnly condensed item={this.state.item?.shippingAddress} />
                            </Card>
                        </div>}
                    </div>
                </>}
                {this.state.error && <Alert type="warning" message={this.state.error} />}
                {this.state.MODEL === 'MNF' && Auth.hasRole('admin') && <Card title="Relations">
                    {this.state.rel?.length > 0 && <table className="table table-bordered">
                        <thead>
                            <tr>
                                <th>Billing</th>
                                <th>Distributor</th>
                                <th>Sub Distributor</th>
                                <th>Shipping</th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.state.rel?.map((i, idx) => <tr key={idx}>
                                <td>{this.highlightSelf(i.billingAccountName, i.billingAccountID)}</td>
                                <td>{this.highlightSelf(i.distributorAccountName, i.distributorAccountID)}</td>
                                <td>{this.highlightSelf(i.subDistributorAccountName, i.subDistributorAccountID)}</td>
                                <td>{this.highlightSelf(i.shippingAccountName, i.shippingAccountID)}</td>
                            </tr>)}
                        </tbody>
                    </table>}
                    {this.state.rel?.length === 0 && <p>No relations found.</p>}
                    {Auth.hasRole('admin') && this.state.accounts && <div>

                        {!this.state.showAddRel
                            && <button type="button" className="btn btn-primary" onClick={() => this.showAddRel()}>Add Relation</button>}
                        {this.state.showAddRel && <form onSubmit={this.submitRel}>
                            <div className="row">
                                <div className="col-md">
                                    <FormInput model={this.state.rel}
                                        name="billingAccountID"
                                        label="Billing Account"
                                        type="select"
                                        options={this.state.accounts.filter(a => a.level === 0)}
                                        onChange={this.changeRel}
                                    />
                                </div>
                                <div className="col-md">
                                    <FormInput model={this.state.rel}
                                        name="distributorAccountID"
                                        label="Distributor Account"
                                        type="select"
                                        options={this.state.accounts.filter(a => a.level > 0)}
                                        onChange={this.changeRel}
                                    />
                                </div>
                                <div className="col-md">
                                    <FormInput model={this.state.rel}
                                        name="subDistributorAccountID"
                                        label="Sub Distributor Account"
                                        type="select"
                                        options={this.state.accounts.filter(a => a.level > 0)}
                                        onChange={this.changeRel}
                                    />
                                </div>
                                <div className="col-md">
                                    <FormInput model={this.state.rel}
                                        name="shippingAccountID"
                                        label="Shipping Account"
                                        type="select"
                                        options={this.state.accounts.filter(a => a.level === 3)}
                                        onChange={this.changeRel}
                                    />
                                </div>
                            </div>
                            <div className="col-md">
                                <button type="submit" className="btn btn-primary" onClick={this.saveRel}>Save</button>
                                <button type="button" className="btn btn-secondary" onClick={() => this.setState({ rel: {}, showAddRel: false })}>Cancel</button>
                            </div>
                        </form>}
                    </div>}
                </Card>}
                {this.state.MODEL === 'MNF' && Auth.hasRole('admin') && this.state.item && <Card title="Purchase Orders">
                    <PurchaseOrders com accountID={this.props.params.id} />
                </Card>}
            </div>
        );
    }
}

export default withParamsAndNavigate(AccountView);